module.exports = __webpack_public_path__ + "media/img/prices/master-card-a4d0f9fade5773e92d974bc20644be7f.svg";